<template>
  <div class="testimonials">
    <div class="testimonials__header">
      <h2>Built for Every Chain</h2>
      <h4>
        Bubblemaps is available across all major blockchains – Solana, Ethereum,
        BNB Chain, Base, Sonic, TON, Tron, and more. Want to see your chain
        supported? Get in touch!
      </h4>
      <Button raised class="testimonials__button" route="/work-with-us">
        Work with us
      </Button>
    </div>
    <!-- 4 COLS -->
    <div
      class="mdc-layout-grid__inner testimonials-4-cols sr_prevent_flickering"
    >
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
        <Ton v-scrollreveal />
        <Cronos v-scrollreveal="{ delay: 150 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient --long"
        ></div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
        <Solana v-scrollreveal />
        <Tron v-scrollreveal="{ delay: 100 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient --long"
        ></div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
        <Bnbchain v-scrollreveal />
        <Sonic v-scrollreveal="{ delay: 150 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient"
        ></div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
        <Avalanche v-scrollreveal />
        <Arbitrum v-scrollreveal="{ delay: 200 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient --long"
        ></div>
      </div>
    </div>
    <!-- 3 COLS -->
    <div class="mdc-layout-grid__inner testimonials-3-cols">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <Solana v-scrollreveal />
        <Tron v-scrollreveal="{ delay: 100 }" />
        <Arbitrum v-scrollreveal="{ delay: 200 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient"
        ></div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <Sonic v-scrollreveal />
        <Avalanche v-scrollreveal="{ delay: 150 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient --long"
        ></div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <Bnbchain v-scrollreveal />
        <Ton v-scrollreveal="{ delay: 100 }" />
        <Cronos v-scrollreveal="{ delay: 200 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient"
        ></div>
      </div>
    </div>
    <!-- 2 COLS -->
    <div class="mdc-layout-grid__inner testimonials-2-cols">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <Solana v-scrollreveal />
        <Ton v-scrollreveal="{ delay: 100 }" />
        <Arbitrum v-scrollreveal="{ delay: 200 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient"
        ></div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <Bnbchain v-scrollreveal />
        <Tron v-scrollreveal="{ delay: 100 }" />
        <Sonic v-scrollreveal="{ delay: 200 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient"
        ></div>
      </div>
    </div>
    <!-- 1 COL -->
    <div class="mdc-layout-grid__inner testimonials-1-cols">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <Solana v-scrollreveal />
        <Bnbchain v-scrollreveal />
        <Ton v-scrollreveal="{ delay: 100 }" />
        <Tron v-scrollreveal="{ delay: 200 }" />
        <Arbitrum v-scrollreveal="{ delay: 200 }" />
        <div
          v-scrollreveal="{ delay: 300 }"
          class="testimonials__gradient"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/atoms/material/Button.vue";
import Solana from "./parts/Solana.vue";
import Bnbchain from "./parts/Bnbchain.vue";
import Avalanche from "./parts/Avalanche.vue";
import Ton from "./parts/Ton.vue";
import Cronos from "./parts/Cronos.vue";
import Arbitrum from "./parts/Arbitrum.vue";
import Sonic from "./parts/Sonic.vue";
import Tron from "./parts/Tron.vue";

export default {
  name: "Testimonials",
  components: {
    Button,
    Solana,
    Bnbchain,
    Avalanche,
    Ton,
    Cronos,
    Arbitrum,
    Sonic,
    Tron,
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.testimonials {
  .testimonials__header {
    text-align: center;
    margin: 40px 0;
  }

  .testimonials__button {
    margin-top: 20px;
  }

  .mdc-layout-grid__cell {
    a {
      margin-bottom: 22px;
    }
  }

  .testimonials__gradient {
    height: 60px;
    background: linear-gradient(180deg, #ffffff17 0%, #ffffff00 100%);
    border-radius: 15px 15px 0 0;

    &.--long {
      height: 90px;
    }

    &.--short {
      height: 40px;
    }
  }
}

@media (max-width: calc($mdc-grid-desktop - 1px)) {
  .testimonials {
    .mdc-layout-grid__cell {
      a {
        margin-bottom: 16px;
      }
    }
  }
}

$breakpoint-4cols: 1100px;

@media (max-width: calc($mdc-grid-tablet - 1px)) {
  .testimonials-1-cols {
    display: grid;
  }
  .testimonials-2-cols {
    display: none;
  }
  .testimonials-3-cols {
    display: none;
  }
  .testimonials-4-cols {
    display: none;
  }
}

@media (min-width: $mdc-grid-tablet) and (max-width: calc($mdc-grid-desktop - 1px)) {
  .testimonials-1-cols {
    display: none;
  }
  .testimonials-2-cols {
    display: grid;
  }
  .testimonials-3-cols {
    display: none;
  }
  .testimonials-4-cols {
    display: none;
  }
}

@media (min-width: $mdc-grid-desktop) and (max-width: calc($breakpoint-4cols - 1px)) {
  .testimonials-1-cols {
    display: none;
  }
  .testimonials-2-cols {
    display: none;
  }
  .testimonials-3-cols {
    display: grid;
  }
  .testimonials-4-cols {
    display: none;
  }
}

@media (min-width: $breakpoint-4cols) {
  .testimonials-1-cols {
    display: none;
  }
  .testimonials-2-cols {
    display: none;
  }
  .testimonials-3-cols {
    display: none;
  }
  .testimonials-4-cols {
    display: grid;
  }
}
</style>
